import { useMutation } from 'react-query';

import type { LoadFileDelimiters } from '../../../../backend/src/integrations/relativity/load-file-import/concordance-dat-parser';
import type { ParseHeaderSampleResponse } from '../../../../backend/src/integrations/relativity/load-file-import/load-file-import-types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface ParseHeaderSampleParams {
  matterId: string;
  importId: string;
  /** Override the auto-detected delimiters/encoding (the wizard's re-parse path). */
  delimiters?: LoadFileDelimiters;
}

/**
 * Detects delimiters/encoding for an uploaded `.dat` and returns its header row
 * plus a handful of sample rows for the mapping wizard.
 */
export const useParseLoadFileHeaderSample = () => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation<ParseHeaderSampleResponse, Error, ParseHeaderSampleParams>(
    async ({ matterId, importId, delimiters }) => {
      const url = `${APIBaseChronos}/api/relativity/load-file-import/${importId}/parse-header-sample?matterId=${matterId}`;
      const response = await fetch(
        url,
        getFetchConfig({ method: FetchMethod.POST, data: delimiters ? { delimiters } : {} }),
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Failed to parse file');
      }

      return response.json();
    },
  );
};

export default useParseLoadFileHeaderSample;
